import * as types from '../constants/ActionTypes'

const notifications = (state = [], action) => {
    switch (action.type) {
      case types.SHOWNOTIFIER:
      return {
          type: "SHOWNOTIFIER",
          cliente: action.cliente,
          texto: action.texto,
          status: action.status,
          idnotifier: action.idnotifier,
          screen: action.screen,
          remote: action.remote
        }
      default:
        return state
    }
  }
  
  export default notifications